export default "__VITE_ASSET__CNIwa6Ks__"